/**
 * Service Router — returns demo or real service implementations
 *
 * Usage:
 *   const { mode } = useAppMode();
 *   const svc = getServices(mode);
 *   svc.dictation.createSession(...)
 */
import * as demo from './demoServices';
import * as real from './realServices';

const demoBundle = {
  dictation: demo.DictationService,
  fhir: demo.FhirService,
  fhirSubscriptions: demo.FhirSubscriptionService,
  lens: demo.LensService,
};

const realBundle = {
  dictation: real.DictationService,
  fhir: real.FhirService,
  fhirSubscriptions: real.FhirSubscriptionService,
  lens: real.LensService,
};

/**
 * Get the full service bundle for the given app mode.
 * @param {'demo' | 'real'} mode
 */
export const getServices = (mode) => mode === 'demo' ? demoBundle : realBundle;

export default getServices;
